<template>
  <f7-card class="private-gym-card card-raised">
    <f7-card-content>
      <template v-if="!showSuccess">
        <p>
          Genereer een nieuw wachtwoord voor dit lid. Het wachtwoord wordt niet
          per e-mail verstuurd.
        </p>
        <f7-button raised fill :loading="loading" :preloader="loading" @click="confirmReset">
          Genereer nieuw wachtwoord
        </f7-button>
      </template>

      <template v-if="showSuccess">
        <p><strong>Wachtwoord is gereset</strong></p>
        <div
          style="
            font-family: monospace;
            font-size: 1.25rem;
            background: var(--f7-card-bg-color, #f8f8f8);
            border: 1px solid var(--f7-list-border-color, #e0e0e0);
            border-radius: 8px;
            padding: 12px 16px;
            margin: 12px 0;
            text-align: center;
            word-break: break-all;
          "
        >
          {{ generatedPassword }}
        </div>
        <div class="display-flex justify-content-center" style="gap: 8px">
          <f7-button tonal @click="copyPassword">
            {{ copied ? "Gekopieerd!" : "Kopieer wachtwoord" }}
          </f7-button>
          <f7-button raised fill color="black" :loading="loading" :preloader="loading" @click="confirmReset">
            Genereer opnieuw
          </f7-button>
        </div>
      </template>
    </f7-card-content>
  </f7-card>
</template>

<script>
import { f7 } from "framework7-vue";

export default {
  props: {
    user: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      generatedPassword: null,
      loading: false,
      copied: false,
      showSuccess: false,
    };
  },

  methods: {
    confirmReset() {
      let vm = this;
      f7.dialog.confirm(
        "Weet je zeker dat je het wachtwoord wilt resetten van " +
          this.user.first_name +
          " " +
          this.user.last_name +
          "?",
        function () {
          vm.resetPassword();
        }
      );
    },

    resetPassword() {
      this.loading = true;
      this.$store
        .dispatch("api/postEndpoint", {
          endpoint: "/users/" + this.user.id + "/reset-password",
        })
        .then((response) => {
          this.generatedPassword = response.data.password;
          this.showSuccess = true;
          this.copied = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    copyPassword() {
      navigator.clipboard
        .writeText(this.generatedPassword)
        .then(() => {
          this.copied = true;
          setTimeout(() => {
            this.copied = false;
          }, 2000);
        })
        .catch(() => {
          this.$store.dispatch("notifications/addDangerNotification", {
            message: "Kopieer het wachtwoord handmatig",
          });
        });
    },
  },
};
</script>
